<template>
  <div v-if="isDataExist" class="leaked-data-cell">
    <v-text-field
      :type="'password'"
      :append-icon="show ? 'visibility' : 'visibility_off'"
      @click:append="onShowClick"
      :value="dataToShow"
      class="leaked-data-input"
      readonly
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'LeakDataTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      hiddenPasswordText: 'HiddenPassword',
    };
  },
  computed: {
    dataToShow() {
      return this.hiddenPasswordText;
    },
    isDataExist() {
      return (this.item.password?.length >= 1 && this.item.password[0]?.length >= 1);
    },
  },
  methods: {
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    async onShowClick() {
      this.show = !this.show;
      this.$emit('showCredentials', this.item.password);
      await this.delay(2000);
      this.show = false;
    },
  },
};

</script>
<style scoped lang="scss">

.leaked-data-input {
  margin-top: 0 !important;
}
</style>
<style lang="scss">
@import '~@/assets/styles/design-system';

.leaked-data-cell {
  width: rem(200);
  .v-icon{
    font-size: rem(18);
    color: var(--text-secondary);
  }
  max-width: 70%;
  .v-text-field > .v-input__control > .v-input__slot:before {
    border-style: none !important;
  }

  .v-text-field > .v-input__control > .v-input__slot:after {
    border-style: none !important;
  }

  .v-text-field > .v-input__control > .v-input__slot {
    background-color: transparent !important;
  }
}
</style>
